import { fetchApi } from '@/services/api-client';

export const SUBJECTS_PATH = '/admin/subjects';

export type Subject = {
  id: string;
  name: string;
  code: string | null;
  color: string | null;
  sortOrder: number;
  active: boolean;
  /** Whether a parent may request their child be excused from one lesson of this subject. */
  parentExcusable: boolean;
  createdAt: string;
  updatedAt: string;
};

export const subjectsApi = {
  list: () => fetchApi<Subject[]>(SUBJECTS_PATH),
  getById: (id: string) => fetchApi<Subject>(`${SUBJECTS_PATH}/${id}`),
  create: (data: {
    name: string;
    code?: string;
    color?: string;
    sortOrder?: number;
    active?: boolean;
    parentExcusable?: boolean;
  }) => fetchApi<Subject>(SUBJECTS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (
    id: string,
    data: {
      name?: string;
      code?: string | null;
      color?: string | null;
      sortOrder?: number;
      active?: boolean;
      parentExcusable?: boolean;
    }
  ) => fetchApi<Subject>(`${SUBJECTS_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${SUBJECTS_PATH}/${id}`, { method: 'DELETE' }),
};
